export const METHODS = {
    _ListMethod: "LIST",
    _StoreMethod: "STORE",
    _PutMethod: "PUT",
    _DeleteMethod: "DELETE",
    _APP_NAME: "ca906389-5169-47ec-b40d-c5659743fb021"
}
